<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Halte 6</p>
            <hr>
        </div>
        <div>
            <div class="text-center">
                <p class="h4 text-center">
                    Historie
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Nu is dit plein vooral een parkeerplaats voor buurtbewoners. Vroeger was het echt een pleintje. Met bankjes en een zandbak. Ik ben er ooit gewond geraakt aan mijn hoofd. Heb jij je ooit pijn gedaan tijdens een spelletje? Gewond geraakt?                 
                </p>
                <p class="text-center d-block margin">
                    Terwijl je hierover vertelt, wandelen we verder.                 
                </p>
            </div>
            <hr class="afterImage">
            <p class="h4 text-center">
                Navigatie
            </p>
            <hr>
            <p class="text-center d-block margin">
                Steek het plein over naar de garageboxen aan de overkant van het plein. Daar kan je opnieuw in een brandweggetje. Sla rechtsaf en loop de brandweg ten einde. Volg daar opnieuw naar rechts en verlaat de brandweg. Sla linksaf de Lotuslaan in en ga meteen weer linksaf de Narcislaan in. Steek de Paalstraat over aan het verkeerslicht.            
            </p>
        </div>
    </div>
    <div class="text-center buttonMargin">
        <button type="button" class="btn btn-primary" [routerLink]="'/halte7'">Volgende stop</button>
    </div>
</div>